
import { toast as sonnerToast, type ToastT } from "sonner";

type ToastProps = {
  title?: string;
  description?: string;
  action?: React.ReactNode;
  variant?: "default" | "destructive";
  duration?: number;
  className?: string; // Added className to support custom styling
};

// Create a wrapper around sonner toast that accepts our custom props
export const toast = ({
  title,
  description,
  action,
  variant = "default",
  duration = 3000,
  className = ""
}: ToastProps) => {
  return sonnerToast(title, {
    description,
    duration,
    action,
    className: variant === "destructive" ? "bg-destructive text-destructive-foreground" : className
  });
};

export const useToast = () => {
  return {
    toast
  };
};
